import {ContentContainer} from '@coolcolduk/ui-mui';
import {Box, Button, CircularProgress} from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import {PrivateRouteProps} from '../../../config/routeType';
import AdminQuestionList from './AdminQuestionList';
import useAdminQuestionPage from './useAdminQuestionPage';

export default function AdminQuestionPage(_props: PrivateRouteProps) {
  const {
    questions,
    filters,
    pagination,
    questionsLoading,
    handleFetchQuestions,
    handleQuestionClick,
    handleCreateNewQuestion,
    QuestionFiltersComponent,
  } = useAdminQuestionPage({defaultFiltersExpanded: true});

  return (
    <ContentContainer data-testid="admin-question-page">
      <PageHeader title="Question Management" />

      <Box sx={{mb: 3, display: 'flex', justifyContent: 'flex-end'}}>
        <Button
          variant="contained"
          onClick={handleCreateNewQuestion}
          sx={{
            bgcolor: '#FF6F59',
            '&:hover': {bgcolor: '#FF6F59', opacity: 0.8},
            color: 'white',
            fontWeight: 600,
            px: 3,
            py: 1,
          }}
        >
          Create New Question
        </Button>
      </Box>

      <QuestionFiltersComponent>
        <Button
          variant="contained"
          onClick={handleFetchQuestions}
          disabled={questionsLoading}
          sx={{
            bgcolor: '#1B263B',
            '&:hover': {bgcolor: '#1B263B', opacity: 0.8},
            height: '56px',
            minWidth: 150,
          }}
        >
          {questionsLoading ? <CircularProgress size={20} color="inherit" /> : 'Fetch Questions'}
        </Button>
      </QuestionFiltersComponent>

      {filters.moduleId && (
        <AdminQuestionList
          questions={questions}
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          startIndex={pagination.startIndex}
          loading={questionsLoading}
          moduleId={filters.moduleId}
          onQuestionClick={handleQuestionClick}
          onPageChange={pagination.gotoPage}
        />
      )}
    </ContentContainer>
  );
}
